import type { VehicleNameSummary } from '@/features/vehiclesearch/services/lookup';
import type { SelectFilterOption } from '@/features/vehiclesearch/types/manualsearch.types';

export const ANY_RESTRICTION_OPTION: SelectFilterOption = { value: '', label: 'Any' };

export const UNRESOLVED_SAVED_LABEL = 'Current selection (unavailable)';

const contains = (options: SelectFilterOption[], id: string) => options.some((option) => option.value === id);

// True when a saved id is missing from a settled active list, so only a by-ids lookup can name it.
export const savedIdNeedsResolving = (
    savedId: string,
    activeOptions: SelectFilterOption[],
    isLoadingActive: boolean,
): boolean => Boolean(savedId) && !isLoadingActive && !contains(activeOptions, savedId);

// Pins a saved id the active list omits, so the shared Select cannot auto-select "Any" over it
// and cannot show "Any" while the form still submits the id.
export const buildRestrictionOptions = (
    activeOptions: SelectFilterOption[],
    savedId: string,
    savedNames: VehicleNameSummary[] | undefined,
): SelectFilterOption[] => {
    const options = [ANY_RESTRICTION_OPTION, ...activeOptions];
    if (!savedId || contains(activeOptions, savedId)) return options;

    const name = savedNames?.find((summary) => summary.id === savedId)?.name;

    return [...options, { value: savedId, label: name ?? UNRESOLVED_SAVED_LABEL }];
};
